import { formatINR } from "@/lib/quotationApi";

export default function SummaryBreakdownTable({ tierList, breakdown }) {
  const b = breakdown;
  if (tierList.length === 0) return null;
  return (
    <div className="card-luxe mb-4 overflow-x-auto">
      <div className="overline text-white/50 mb-3">Breakdown by tier</div>
      <table className="w-full text-sm min-w-[360px]">
        <thead>
          <tr className="text-[10px] uppercase tracking-wider text-white/40 border-b border-white/5">
            <th className="text-left font-normal py-2">&nbsp;</th>
            {tierList.map((t) => (
              <th
                key={t.id}
                className="text-right font-normal py-2 px-2"
                style={{ color: t.color }}
              >
                {t.name}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {[
            { label: "Area cost", get: (x) => x.area_cost, testId: "area-cost" },
            { label: "Accessories", get: (x) => x.accessories_cost, testId: "accessories-cost" },
            { label: "Subtotal", get: (x) => x.subtotal },
          ].map((row) => (
            <tr key={row.label} className="border-b border-white/5 last:border-0">
              <td className="text-white/70 py-1.5">{row.label}</td>
              {tierList.map((t) => (
                <td
                  key={t.id}
                  className="text-right text-white/90 py-1.5 px-2 whitespace-nowrap"
                  data-testid={row.testId ? `${row.testId}-${t.id}` : undefined}
                >
                  {formatINR(row.get(t.breakdown))}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      {b.discount > 0 && (
        <div className="flex justify-between text-sm pt-2 text-red-300/80">
          <div>Discount (applied to all tiers)</div>
          <div>− {formatINR(b.discount)}</div>
        </div>
      )}
      {b.taxPct > 0 && (
        <div className="flex justify-between text-sm text-white/60">
          <div>Tax</div>
          <div>{b.taxPct}%</div>
        </div>
      )}
    </div>
  );
}
